import React from 'react'
import styled from 'styled-components'
import { NavLink as RouterNavLink, NavLinkProps } from 'react-router-dom'

import {
  Grid,
  Link,
  Typography,
} from '@material-ui/core'

const NavLink = React.forwardRef((props: NavLinkProps, ref: React.Ref<HTMLAnchorElement>) => (
  <RouterNavLink innerRef={ref} {...props} />
))
NavLink.displayName = 'NavLink'

const Centered = styled.div`
  text-align: center;
`

export const NotFound = () => {
  return (
    <Centered>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Typography variant="h3">
            Error 404
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h2">
            Do you have the right SKU?
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>
            It looks like the page your looking for cannot be found!
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Link component={NavLink} exact to="/">
            Go Home
          </Link>
        </Grid>
        <Grid item xs={12}>
          <Link component={NavLink} exact to="/auth/logout">
            Logout
          </Link>
        </Grid>
      </Grid>
    </Centered>
  )
}
